(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jump-depoimentos"] && !Shopify.designMode) return;
  try {
    
(function() {
  var track = document.getElementById('jumpDepTrack');
  var dotsContainer = document.getElementById('jumpDepDots');
  if (!track || !dotsContainer) return;
  var cards = track.querySelectorAll('.jump-dep__card');
  if (!cards.length) return;
  cards.forEach(function(_, i) {
    var dot = document.createElement('button');
    dot.className = 'jump-dep__dot' + (i === 0 ? ' active' : '');
    dot.setAttribute('aria-label', 'Depoimento ' + (i + 1));
    dot.addEventListener('click', function() {
      cards[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    });
    dotsContainer.appendChild(dot);
  });
  track.addEventListener('scroll', function() {
    var idx = Math.round(track.scrollLeft / (cards[0].offsetWidth + 16));
    dotsContainer.querySelectorAll('.jump-dep__dot').forEach(function(d, i) {
      d.classList.toggle('active', i === idx);
    });
  }, { passive: true });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
